
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import anime from "animejs"

@Component
export default class AnimatedNumber extends Vue {
  @Prop({required: true})
  value?: number | "∞"

  @Prop({default: 0})
  decimals: number

  animatedValue: number | string | null = null

  get displayValue() {
    if (this.animatedValue === this.value) {
      return this.animatedValue
    } else if (typeof this.animatedValue === "string") {
      return this.value
    } else {
      // While animating display decimals to minimized the numbers "jumping"
      // but when displaying the final value prefer '0%' over '0.0%'
      return this.animatedValue?.toFixed(this.decimals)
    }
  }

  mounted() {
    this.animatedValue = this.value ?? 0
    this.$watch(
      () => this.value,
      n => {
        anime({
          targets: this,
          animatedValue: n,
          round: 10 ** this.decimals,
          easing: "linear",
          duration: 500,
        })
      },
      {immediate: false}
    )
  }
}
